import { render, staticRenderFns } from "./PictureWithText.vue?vue&type=template&id=284b37b8&scoped=true&"
import script from "./PictureWithText.vue?vue&type=script&lang=js&"
export * from "./PictureWithText.vue?vue&type=script&lang=js&"
import style0 from "./PictureWithText.vue?vue&type=style&index=0&id=284b37b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b37b8",
  null
  
)

export default component.exports